import { render, staticRenderFns } from "./ChapterOverlay.vue?vue&type=template&id=2d336272&scoped=true&"
import script from "./ChapterOverlay.vue?vue&type=script&lang=js&"
export * from "./ChapterOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ChapterOverlay.vue?vue&type=style&index=0&id=2d336272&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d336272",
  null
  
)

export default component.exports